// extracted by mini-css-extract-plugin
module.exports = {"bg":"Paginado_bg__IXe1P","btn":"Paginado_btn__1wflt"};